import React from "react";

interface PendingSettlementsIconProps
  extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
}

export const PendingSettlementsIcon: React.FC<
  PendingSettlementsIconProps
> = ({ size = 60, className, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Outer Circle */}
      <circle
        cx="30"
        cy="30"
        r="29"
        stroke="currentColor"
        strokeWidth="1.5"
      />

      {/* Inner Clock Circle */}
      <circle
        cx="30"
        cy="30"
        r="13"
        stroke="currentColor"
        strokeWidth="2"
      />

      {/* Clock Hand */}
      <path
        d="M30 23V30L35 33"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};